<template>
    <div class="filtered flex-y-center" v-if="searching">
        <span><b>Filter:</b> <span v-for="(filter, f) in list" :key="f">{{ filter }}<span v-if="f < list.length - 1">, </span></span></span>
    </div>
</template>

<script>
export default {
    name: "SearchList",
    props: {
        list: Array,
        searching: Boolean
    }
};
</script>